import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./modal.css";

import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Badge from "@mui/material/Badge";
import { Button } from "react-bootstrap";

import Table from "../../Theme/Table.js";
import AddAgent from "./AddAgent";
import EditAgent from "./EditAgent";
import DeleteConfirmation from "../../deleteConfirmation";
import AgentRegisteredDrivers from "../../Drivers/AgentRegisteredDrivers";

const SubAgent = () => {
  const edit = "agentDetails";
  const detail = "driver-by-sub-agent";
  const agentParamId = useParams();
  console.log("==============agent======id===", agentParamId);
  const [id, setId] = useState(null);

  const showEditModal = (id) => {
    setId(id);

    axios
      .get("/sub-agent/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("d4uToken")}`,
          // Other headers if required
        },
      })
      .then((res) => {
        setData(res.data.subAgent);

        setDisplayEditModal(true);
      });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [data, setData] = useState(null);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this sub-agent`);
    setDisplayConfirmationModal(true);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Sub Agent Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Phone",
            accessor: "phone",
            disableFilters: true,
          },
          {
            Header: "Email",
            accessor: "email",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              >
                <Link
                  to={""}
                  onClick={(e) => showEditModal(row.cell.row.original.id)}
                >
                  <i className="fas fa-edit info" />
                </Link>
                <Link
                  style={{ marginLeft: "0px" }}
                  to={""}
                  onClick={(e) => showDeleteModal(row.cell.row.original.id)}
                >
                  <i className="fas fa-trash error" />
                </Link>
                <Link
                  style={{ marginLeft: "0px" }}
                  to={"/" + detail + "/" + row.cell.row.original.id}
                >
                  <i className="fas fa-eye success" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );
  const notify = () =>
    toast.success("Agent list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getAgents();
  }, []);

  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [agents, setAgents] = useState([]);

  const getAgents = async () => {
    let user = JSON.parse(localStorage.getItem("userData"));
    const response = await axios.get("sub-agents/" + user.id).then(notify());
    setAgents(response.data);
  };
  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const submitDelete = (id) => {
    console.log(id);
    deleteAgent(id);
    setDisplayConfirmationModal(false);
  };
  const deleteAgent = async (id) => {
    const response = await axios.delete("/sub-agent/" + id, {
      data: { id: id },
    });
    getAgents();
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  return (
    <div className="">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Sub Agents</h3>
            <Button
              onClick={() => showAddModal()}
              className="btn btn-success bt"
            >
              <Link to={"/addSubAgent"} className="nav-link">
                <p>
                  {" "}
                  <i class="nav-icon fas fa-plus"></i>Add Sub Agent
                </p>
              </Link>
            </Button>
          </div>

          <div className="card-body">
            <Table
              columns={columns}
              data={agents}
              edit={edit}
              detail={detail}
            />
          </div>
        </div>
      </div>
      {/* <AgentRegisteredDrivers /> */}
      {/* </div> */}
      {/* </div> */}
      {/* </section> */}
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      <AddAgent
        getAgents={getAgents}
        showModal={displayAddModal}
        hideModal={hideAddModal}
        agentId={agentParamId.id}
      />
      {displayEditModal == true && (
        <EditAgent
          getAgents={getAgents}
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
          agentId={agentParamId.id}
        />
      )}
    </div>
  );
};
export default SubAgent;
